/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./widgetMetaEditor.vue?vue&type=template&id=366324a9"
import script from "./widgetMetaEditor.vue?vue&type=script&lang=js"
export * from "./widgetMetaEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports